import { useArticleSubCategoryRoutes } from "./routes";
import { GetDefaultIndex } from "../../components";
import { useGetArticleSubCategoryCommonInfoQuery } from "../../features/articles/articlesSlice";

export { useArticleSubCategoryRoutes };

export default GetDefaultIndex({ title: "زیرگروه‌های مقالات", query: useGetArticleSubCategoryCommonInfoQuery });
